

















































































import Vue from 'vue'
import { Action, Getter } from 'vuex-class'
import { Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'
import { NavItem } from '@/utils/types'

@Component
export default class Navigation extends Vue {
  @Getter jwt!: string;
  @Action signOut!: () => void;
  @Prop(Boolean) readonly isOpen!: boolean;
  get navItems (): NavItem[] {
    return [
      {
        icon: 'mdi-account-circle',
        text: 'משתמשים',
        to: '/users',
        visible: () => {
          return !!this.jwt
        }
      },
      {
        icon: 'mdi-currency-usd',
        text: 'מעסיקים',
        to: '/employers',
        visible: () => {
          return !!this.jwt
        }
      },
      {
        icon: 'mdi-clipboard-account',
        text: 'עבודות',
        to: '/jobs',
        visible: () => {
          return !!this.jwt
        }
      },
      {
        icon: 'mdi-briefcase',
        text: 'משרות',
        to: '/job-listings',
        visible: () => {
          return !!this.jwt
        }
      },
      {
        icon: 'mdi-map',
        text: 'אזורי תעסוקה',
        to: '/areas',
        visible: () => {
          return !!this.jwt
        }
      },
      {
        icon: 'mdi-bank',
        text: 'רשויות',
        to: '/authorities',
        visible: () => {
          return !!this.jwt
        }
      },
      {
        icon: 'mdi-source-branch',
        text: 'ענפים',
        to: '/branches',
        visible: () => {
          return !!this.jwt
        }
      },
      {
        icon: 'mdi-state-machine',
        text: 'אלגוריתמים',
        to: '/algorithms',
        visible: () => {
          return !!this.jwt
        }
      },
      {
        icon: 'mdi-file-outline',
        text: 'מאמרים',
        to: '/articles',
        visible: () => {
          return !!this.jwt
        }
      },
      {
        icon: 'mdi-bell-ring-outline',
        text: 'תבניות פושים',
        to: '/push-templates',
        visible: () => {
          return !!this.jwt
        }
      },
      {
        icon: 'mdi-cog-outline',
        text: 'הגדרות',
        visible: () => {
          return !!this.jwt
        },
        showSubItems: false,
        subItems: [
          {
            icon: 'mdi-wrench-cog-outline',
            text: 'כללי',
            to: '/general-configurations',
            visible: () => {
              return !!this.jwt
            }
          },
          {
            icon: 'mdi-star-four-points-outline',
            text: 'מסלולי פרסום',
            to: '/job-plans-configurations',
            visible: () => {
              return !!this.jwt
            }
          }
        ]
      },
      {
        icon: 'mdi-logout',
        text: 'יציאה',
        to: '/login',
        visible: () => {
          return !!this.jwt
        },
        click: () => {
          this.signOut()
        }
      }
    ]
  }

  get visibleNavItems () {
    return this.navItems.filter(
      (n) => n.visible === null || n.visible.apply(this)
    )
  }

  get isNavOpen () {
    return this.isOpen && this.visibleNavItems.length > 0
  }

  set isNavOpen (value) {
    this.$emit('openNavigationChanged', value)
  }

  executeNavItemClick (item: NavItem) {
    item.click && item.click()
  }
}
